import { createContext, useContext, useEffect, useState, useCallback } from "react";
import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;
const CompanyContext = createContext(null);

// hex "#RRGGBB" → "H S% L%" for shadcn CSS vars
export function hexToHslString(hex) {
  if (!hex) return "342 68% 33%";
  const h = hex.replace("#", "");
  const full = h.length === 3 ? h.split("").map(c => c + c).join("") : h;
  const r = parseInt(full.slice(0, 2), 16) / 255;
  const g = parseInt(full.slice(2, 4), 16) / 255;
  const b = parseInt(full.slice(4, 6), 16) / 255;
  const max = Math.max(r, g, b), min = Math.min(r, g, b);
  let hh = 0, s = 0; const l = (max + min) / 2;
  if (max !== min) {
    const d = max - min;
    s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
    switch (max) {
      case r: hh = (g - b) / d + (g < b ? 6 : 0); break;
      case g: hh = (b - r) / d + 2; break;
      case b: hh = (r - g) / d + 4; break;
      default: break;
    }
    hh /= 6;
  }
  return `${Math.round(hh * 360)} ${Math.round(s * 100)}% ${Math.round(l * 100)}%`;
}

const applyBrand = (settings) => {
  if (!settings) return;
  const primary = hexToHslString(settings.brand_primary || "#8D1B3D");
  const secondary = hexToHslString(settings.brand_secondary || "#747678");
  const root = document.documentElement;
  root.style.setProperty("--primary", primary);
  root.style.setProperty("--ring", primary);
  root.style.setProperty("--chart-1", primary);
  root.style.setProperty("--brand-primary", settings.brand_primary || "#8D1B3D");
  root.style.setProperty("--brand-secondary", settings.brand_secondary || "#747678");
  // iter163.3 — /panel'de "Bordo Yönetim" başlığını kalıcı tut; sadece storefront'ta company_name'e set et
  const isPanel = typeof window !== "undefined" && window.location.pathname.startsWith("/panel");
  if (settings.company_name && !isPanel) document.title = settings.company_name;
  if (settings.favicon_url) {
    let link = document.querySelector("link[rel~='icon']");
    if (!link) { link = document.createElement("link"); link.rel = "icon"; document.head.appendChild(link); }
    link.href = settings.favicon_url;
  }
};

export const CompanyProvider = ({ children }) => {
  const [company, setCompany] = useState(null);

  const refresh = useCallback(async () => {
    try {
      const { data } = await axios.get(`${BASE}/api/public/company`);
      setCompany(data);
      applyBrand(data);
    } catch (e) {
      // fail silently, keep defaults
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  return (
    <CompanyContext.Provider value={{ company, refresh, setCompany: (c) => { setCompany(c); applyBrand(c); } }}>
      {children}
    </CompanyContext.Provider>
  );
};

export const useCompany = () => useContext(CompanyContext) || { company: null };
